import Cookie from 'js-cookie';
import { configureApi } from 'react-reqq-lite';

import { toastError } from 'modules/common';
import { getFirstMessage, jsUcOnlyFirst } from 'modules/common/utils';

import history from './history';

export const END_POINT = process.env.REACT_APP_END_POINT;
const hasToken = Cookie.get('_token');

const store = configureApi({
  endpoint: END_POINT,
  requestHeaders: () => {
    const token = Cookie.get('_token');
    if (!token)
      return {
        'Content-Type': 'application/json',
      };
    return {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  },
  timeout: 180000,
  onError: (err) => {
    try {
      const dispatchError = {
        400: () => {
          const message = err?.response?.message;
          toastError(message);
        },
        401: () => {
          const { message = '' } = err?.response?.data;
          toastError(message);
        },
        403: () => {
          const { message, error } = err?.response;
          const isError =
            error === 'token_expired' ||
            error === 'token_invalid' ||
            error === 'token_missing';

          if (isError && hasToken) {
            toastError(message);
            history.push('/logout');
            return;
          }
          toastError(message);
        },
        404: () => {
          const { message } = err?.response;
          toastError(jsUcOnlyFirst(message));
        },
        422: () => {
          const { errors } = err?.response;
          if (typeof errors === 'string') {
            toastError(errors?.message);
            return;
          }
          toastError(getFirstMessage(errors));
        },
        429: () => {
          toastError('Too many attempts!');
        },
        500: () => toastError('Unable to communicate with server'),
      };
      return dispatchError[err.status] && dispatchError[err.status]();
    } catch (error) {
      return null;
    }
  },
});

export default store;
